import { CustomerQuote as CustomerQuoteADF } from './adf';
import { CustomerQuote as CustomerQuoteASM } from './asm';
import { CustomerQuote as CustomerQuoteCAP } from './cap';
import { CustomerQuote as CustomerQuoteCSC } from './csc';
import { CustomerQuote as CustomerQuoteGRE } from './gre';
import { CustomerQuote as CustomerQuoteMMC } from './mmc';
import { CustomerQuote as CustomerQuoteMWS } from './mws';
import { CustomerQuote as CustomerQuotePON } from './pon';
import { CustomerQuote as CustomerQuoteRAF } from './raf';
import { CustomerQuote as CustomerQuoteSPM } from './spm';
import { CustomerQuote as CustomerQuoteUSA } from './usa';
import { CustomerQuote as CustomerQuoteWWP } from './wwp';

interface PDFMap {
  [key: string]: React.FunctionComponent | undefined;
  default: React.FunctionComponent;
}

export const sitePDFs: PDFMap = {
  ADF: CustomerQuoteADF,
  ASM: CustomerQuoteASM,
  BTL: CustomerQuoteASM,
  CAP: CustomerQuoteCAP,
  CSC: CustomerQuoteCSC,
  GRE: CustomerQuoteGRE,
  HPC: CustomerQuoteASM,
  MMC: CustomerQuoteMMC,
  MWS: CustomerQuoteMWS,
  PON: CustomerQuotePON,
  RAF: CustomerQuoteRAF,
  SPM: CustomerQuoteSPM,
  WWP: CustomerQuoteWWP,
  USA: CustomerQuoteUSA,
  default: CustomerQuoteCAP, // TODO: prob not what we want since branded, could use corp branding + Site address, etc
};
